import { Icon } from '@iconify/react';
import SearchableDropdown from '../../../../../components/SearchableDropdown';

const MemberFilters = ({
    searchQuery,
    onSearchChange,
    filterWing,
    onWingChange,
    filterFlat,
    onFlatChange,
    wings,
    flats,
    wingsLoading,
    flatsLoading,
    viewMode,
    onViewModeChange,
    onClearFilters,
    hasActiveFilters,
    showing,
    total,
}) => {
    return (
        <div className="tw-bg-white tw-rounded-lg tw-py-2.5 tw-px-3 tw-mb-4 tw-shadow-sm tw-border tw-border-gray-100 tw-flex tw-items-center tw-gap-2.5 tw-flex-wrap">
            <div className="tw-flex-1 tw-min-w-[200px] tw-relative">
                <Icon icon="mdi:magnify" className="tw-absolute tw-left-2.5 tw-top-1/2 tw--translate-y-1/2 tw-text-gray-400 tw-text-sm" />
                <input
                    type="text"
                    placeholder="Search by name, phone or email..."
                    value={searchQuery}
                    onChange={(e) => onSearchChange(e.target.value)}
                    className="tw-w-full tw-pl-8 tw-pr-2 tw-py-1.5 tw-border tw-border-gray-200 tw-rounded-md tw-text-sm focus:tw-outline-none focus:tw-border-blue-500"
                />
            </div>
            <SearchableDropdown
                value={filterWing}
                onChange={onWingChange}
                options={wings}
                valueKey="wing_id"
                labelKey="title"
                placeholder="All Wings"
                loading={wingsLoading}
            />
            <SearchableDropdown
                value={filterFlat}
                onChange={onFlatChange}
                options={flats}
                valueKey="flat_id"
                labelKey="flat_number"
                placeholder="All Flats"
                loading={flatsLoading}
            />
            {hasActiveFilters && (
                <button onClick={onClearFilters} className="tw-flex tw-items-center tw-gap-1 tw-text-red-500 tw-text-xs tw-font-medium hover:tw-text-red-600">
                    <Icon icon="mdi:close" className="tw-text-sm" /> Clear
                </button>
            )}
            <div className="tw-flex tw-bg-gray-100 tw-rounded-lg tw-p-1">
                <button
                    onClick={() => onViewModeChange('grid')}
                    className={`tw-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-rounded-md tw-text-sm tw-font-medium tw-transition-all ${viewMode === 'grid' ? 'tw-bg-white tw-text-blue-600 tw-shadow-sm' : 'tw-text-gray-500 hover:tw-text-gray-700'}`}
                >
                    <Icon icon="mdi:view-grid" className="tw-text-base" />
                    <span className="tw-hidden sm:tw-inline">Grid</span>
                </button>
                <button
                    onClick={() => onViewModeChange('list')}
                    className={`tw-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-rounded-md tw-text-sm tw-font-medium tw-transition-all ${viewMode === 'list' ? 'tw-bg-white tw-text-blue-600 tw-shadow-sm' : 'tw-text-gray-500 hover:tw-text-gray-700'}`}
                >
                    <Icon icon="mdi:view-list" className="tw-text-base" />
                    <span className="tw-hidden sm:tw-inline">List</span>
                </button>
            </div>
            <span className="tw-text-[11px] tw-text-gray-400 tw-ml-auto">Showing {showing} of {total}</span>
        </div>
    );
};

export default MemberFilters;
